import React, { PropsWithChildren } from 'react';

import { I18nContextType } from '@ecg-marktplaats/js-react-i18n';
import { FluidAsset, TAsset, TextLarge, Title5 } from '@hz-design-system/web-ui';

import { ModalProps } from '../types';

import Classes from './BuyerProtectionModal.module.scss';

export const TopSection = ({
  assetName,
  description,
  title,
}: {
  assetName: TAsset;
  title: string;
  description?: string;
}) => (
  <div className={Classes.topSection}>
    <div className={Classes.image}>
      <FluidAsset name={assetName} className={Classes.imageAsset} />
    </div>
    <Title5 className={Classes.title}>{title}</Title5>
    {description && <div className={Classes.description}>{description}</div>}
  </div>
);

export const TextContentBlock = ({
  title,
  description,
  descriptionClassName,
}: {
  title: string;
  description: string;
  descriptionClassName?: string;
}) => (
  <>
    <TextLarge as="strong">{title}</TextLarge>
    <TextLarge className={descriptionClassName}>{description}</TextLarge>
  </>
);

export const PointItem = ({ title, description }: { title: string; description: string }) => (
  <li className={Classes.pointItem}>
    <TextContentBlock title={title} description={description} />
  </li>
);

export const Points = ({ title, children }: PropsWithChildren<{ title: string }>) => (
  <>
    <Title5 className={Classes.pointTitle}>{title}</Title5>
    <ul className={Classes.pointsList}>{children}</ul>
  </>
);

/**
 * Inject onClose to each button
 * Revisit this when modal needs not be closed on button click
 */
export const getModalButtons = ({
  buttons,
  onClose,
  t,
}: {
  onClose: () => void;
  t: I18nContextType['t'];
  buttons: ModalProps['buttons'];
}) => {
  return (
    buttons?.map((button) => {
      return {
        ...button,
        ...{
          onClick:
            'onClick' in button
              ? () => {
                  button.onClick?.();
                  onClose();
                }
              : undefined,
        },
      } as Required<ModalProps>['buttons'][number];
    }) ?? [
      {
        component: 'PrimaryButton',
        text: t('p2pPaymentsUi:dynamicCoverageInfoModal.okButtonLabel'),
        onClick: onClose,
      },
    ]
  );
};
